export const formatNumber = (num?: number): string | undefined => {
	if (num === undefined || num === null || isNaN(Number(num))) return undefined;
	return Number(num)
		.toFixed(2)
		.replace(/\./g, ",")
		.replace(/(\d)(?=(\d{3})+,)/g, "$1.");
};
